import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private jsonUrl = '../../assets/data/projects.json';
  // private jsonUrl = '../../assets/data/project-master.json';

  constructor(private http: HttpClient) { }

  getProjects(): Observable<any> {
    return this.http.get<any>(this.jsonUrl);
  }

  getProjectById(id: string): Observable<any> {
    return this.http.get<any>(`${this.jsonUrl}?id=${id}`);
  }
}